import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import documentTypeList from "./documentTypeList.vue";
import writeDocument from "./writeDocument.vue";
import documentVersion from "./documentVersion.vue";
import recallTest from "./recallTest.vue";
export default {
  name: "knowledgeManagement",
  components: {
    documentTypeList: documentTypeList,
    writeDocument: writeDocument,
    documentVersion: documentVersion,
    recallTest: recallTest
  },
  data: function data() {
    return {
      activeIndex: 'documentTypeList'
    };
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};